(ns renolit-roofing-service.layout.form.form-item.input
  (:require [cljc.java-time.format.date-time-formatter :as jt.formatter]
            [cljc.java-time.local-date :as jt.local-date]
            [goog.object :as g]
            [goog.string :as gstring]
            [goog.string.format]
            [malli.core :as m]
            [malli.transform :as mt]
            [re-frame.core :as rf]
            [reagent.core :as r]
            [renolit-roofing-service.layout.form.error :as form.error]
            [renolit-roofing-service.layout.form.form-item :as form.form-item]
            [renolit-roofing-service.layout.icon :as layout.icon]
            [renolit-roofing-service.localization :refer [t]]
            [renolit-roofing-service.util :as util]))

(defn- date-picker-value->value
  [date-picker-value]
  (when date-picker-value
    (->> (jt.formatter/parse jt.formatter/iso-local-date date-picker-value)
         (jt.local-date/from))))

(defn- value->date-picker-value
  [value]
  (when value
    (jt.formatter/format jt.formatter/iso-local-date value)))

(defn- on-change-event-handler
  [{:keys [schema input-type] :or {schema [:string]} :as opts}]
  (fn [e]
    (let [event-value (g/getValueByKeys e "target" "value")
          new-value (when (seq event-value)
                      (if (= :date input-type)
                        (date-picker-value->value event-value)
                        (m/decode schema event-value mt/string-transformer)))]
      (form.form-item/on-change-event-handler opts :on-change new-value))))

(defn- build-number-validity-regex
  [{:keys [schema]
    {:keys [allow-negative max-fraction-digits]} :number-opts}]
  (let [fractions-quantifier (if max-fraction-digits
                               (gstring/format "{0,%d}" max-fraction-digits)
                               "*")
        negative-part (if allow-negative "-?" "")]
    (re-pattern
     (if (= :double (m/type schema))
       (gstring/format "^$|^%s[0-9]*[.]?[0-9]%s$" negative-part fractions-quantifier)
       (gstring/format "^$|^%s[0-9]*$" negative-part)))))

(defn- on-change-event-handler-number
  [{:keys [schema] :as opts} tmp-value]
  (let [valid-value-regex (build-number-validity-regex opts)
        unfinished-value-regex #"^-$|^-?[0-9]+[.]$|^-?[0-9]+[.][0-9]*0$"]
    (fn [e]
      (let [event-value (g/getValueByKeys e "target" "value")]
        (when (re-matches valid-value-regex event-value)
          (let [new-value (m/decode schema event-value mt/string-transformer)]
            (if (re-matches unfinished-value-regex event-value)
              (reset! tmp-value event-value)
              (reset! tmp-value nil))
            (form.form-item/on-change-event-handler opts :on-change new-value)))))))

(defn- on-blur-event-handler
  [{:keys [on-blur]}]
  (fn [_]
    (util/execute-callback on-blur)))

(defn- on-focus-event-handler
  [{:keys [on-focus]}]
  (fn [_]
    (util/execute-callback on-focus)))

(defn- on-click-event-handler
  [{:keys [on-click]}]
  (fn [_]
    (util/execute-callback on-click)))

(defn- on-input-event-handler
  [{:keys [on-input]}]
  (fn [_]
    (util/execute-callback on-input)))

(defmethod form.form-item/form-item-component :input
  [{:keys [context path] :as _opts}]
  (let [component-id (str (random-uuid))
        form-errors (rf/subscribe [::form.error/errors context path])
        tmp-value (r/atom nil)]
    (fn [{:keys [state path disabled? label placeholder icon-kw on-icon-click
                 label-transl-kw placeholder-transl-kw unit-transl-kw
                 input-opts css-class-prefix input-type full-line?
                 on-blur on-focus on-click mandatory? on-input read-only?]
          :as opts}]
      [:div.form-item
       {:class [(when disabled? "form-item--disabled")
                (when css-class-prefix css-class-prefix)
                (when full-line? "form-item--full-line")
                (when (seq @form-errors) "form-item--error")]}
       (when (or label-transl-kw label)
         [:label.form-item__label
          (cond-> {:for component-id}
            css-class-prefix
            (assoc :class (str css-class-prefix "__label"))

            (seq @form-errors)
            (assoc :title (form.error/form-error->msg (first @form-errors))))
          (or (t [label-transl-kw]) label)
          (when mandatory?
            [:span.form-item__mandatory "*"])])
       [:div.form-item__input-wrapper
        (when css-class-prefix
          {:class (str css-class-prefix "__wrapper")})
        [:input.form-item__input
         (cond-> {:id component-id
                  :disabled (boolean disabled?)
                  :value (cond-> (or @tmp-value (get-in @state path))
                           (= :date input-type)
                           (value->date-picker-value)

                           :always
                           (or ""))
                  :on-change (on-change-event-handler opts)
                  :class []}
           placeholder-transl-kw
           (assoc :placeholder (t [placeholder-transl-kw]))

           placeholder
           (assoc :placeholder placeholder)

           read-only?
           (assoc :read-only read-only?)

           (seq on-blur)
           (assoc :on-blur (on-blur-event-handler opts))

           (seq on-focus)
           (assoc :on-focus (on-focus-event-handler opts))

           (seq on-click)
           (assoc :on-click (on-click-event-handler opts))

           (seq on-input)
           (assoc :on-input (on-input-event-handler opts))

           css-class-prefix
           (update :class conj (str css-class-prefix "__input"))

           input-type
           (->
            (assoc :type input-type)
            (update :class conj (str "form-item__input--" input-type)))

           (= "number" input-type)
           (assoc :type "text"
                  :on-change (on-change-event-handler-number opts tmp-value))

           input-opts
           (merge input-opts))]
        (when unit-transl-kw
          [:div.form-item__unit-indicator
           (t [unit-transl-kw])])
        (when icon-kw
          [layout.icon/icon
           (cond-> {:key icon-kw
                    :class "input_icon"
                    :clickable? true}
             on-icon-click (assoc :props {:on-click on-icon-click}))])]
       (when (seq @form-errors)
         [form.error/error-label @form-errors])])))
